import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NotificationSystem from 'react-notification-system';

import Icon from 'constants/icons';

const mapStateToProps = (state) => ({
    message: state.notificationReducer.message,
    level: state.notificationReducer.level,
    icon: state.notificationReducer.icon,
    id: state.notificationReducer.id,
});

const NotificationContainer = ({ icon, message, level, id }) => {
    const notificationSystem = React.useRef();

    React.useEffect(() => {
        const notification = notificationSystem.current;
        notification.addNotification({
            // title: Icon[icon],
            message,
            level,
        });
    }, [id]);

    return <NotificationSystem ref={notificationSystem} />;
};

NotificationContainer.propTypes = {
    message: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired,
    // icon: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, null)(NotificationContainer);
